import React from "react";
import { MENTOR_CATEGORIES } from "../../../data/mentorshipData";

const countFor = (mentors, category) =>
  category === "All"
    ? mentors.length
    : mentors.filter((mentor) => mentor.cats.includes(category)).length;

// "chips" = horizontally scrolling pills (mobile home),
// "list" = vertical list with counts (desktop sidebar).
const CategoryFilter = ({ variant = "chips", mentors, active, onSelect }) => {
  if (variant === "list") {
    return (
      <ul className="ms-cat-list">
        {MENTOR_CATEGORIES.map((category) => (
          <li key={category}>
            <button
              type="button"
              className={`ms-cat-item ${category === active ? "is-on" : ""}`}
              aria-pressed={category === active}
              onClick={() => onSelect(category)}
            >
              <span>{category}</span>
              <span className="ms-cat-count">
                {countFor(mentors, category)}
              </span>
            </button>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className="ms-chips">
      {MENTOR_CATEGORIES.map((category) => (
        <button
          key={category}
          type="button"
          className={`ms-chip ${category === active ? "is-on" : ""}`}
          aria-pressed={category === active}
          onClick={() => onSelect(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
